import { createSelector } from 'reselect';

import { getScopeTotalParts } from 'lib/selectors/getScopeTotalParts';
import { getScopePartAdjustmentData } from 'lib/selectors/getScopePartAdjustmentData';

// Parts made on the current job (Utilization "You have made"). Labor-ticket unsubmitted uses getLaborScopeTotalParts.
const getScopeNetPartsMade = createSelector(
  [getScopeTotalParts, getScopePartAdjustmentData],
  (scopeTotalParts, { scopeTotalNetPartAdjustments }) => {
    return scopeTotalParts + scopeTotalNetPartAdjustments;
  }
);

export { getScopeNetPartsMade };
